/* @flow */
import type { Action } from "../action";
import type { StockID, StockCategory, Stock } from "../CommonTypes";

type Assets = {
  [key: StockCategory]: Array<Stock>
};

export type State = null | {
  [key: StockID]: Stock
};

function stocksById(stocks: Array<Stock>, category) {
  return stocks.reduce(
    (result, stock) => ({
      ...result,
      [stock.stock]: { ...stock, category }
    }),
    {}
  );
}

function receiveStockAssets(assets?: Assets) {
  if (typeof assets === "undefined") {
    throw new TypeError("Assets must be an object");
  }

  const categories = Object.keys(assets);

  return categories.reduce(
    (result, category) => ({
      ...result,
      ...stocksById(assets ? assets[category] : [], category)
    }),
    {}
  );
}

function receiveSocketMessage(state, message) {
  if (state == null) {
    return state;
  }

  switch (message.op) {
    case "percent-updated": {
      const prevStock = state[message.channel];

      if (prevStock == null) {
        return state;
      }

      return {
        ...state,
        [message.channel]: {
          ...prevStock,
          realProfit: message["profit-percent"] + prevStock.profit_vip
        }
      };
    }
    case "schedule-updated":
      return {
        ...state,
        [message.channel]: {
          ...state[message.channel],
          enabled: message.enabled,
          state_changed_at: message.state_changed_at
        }
      };
    default:
      return state;
  }
}

function stocks(state: State = null, action: Action): State {
  switch (action.type) {
    case "RECEIVE_STOCK_ASSETS":
      return receiveStockAssets(action.payload);
    case "RECEIVE_SOCKET_MESSAGE":
      return receiveSocketMessage(state, action.payload);
    default:
      return state;
  }
}

export default stocks;

export function getTimeUntilNextLockToggle(time: number, stock: Stock): number {
  if (stock && stock.state_changed_at != null) {
    return Math.max(0, stock.state_changed_at * 1000 - time);
  } else {
    return Infinity;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducer/stocks.js